import { sanitize } from 'dompurify';
// dompurify is a replacement for sanitize-html which was not supposed to be working on client and increased bundle size up to additional 60kb;
// whereas dompurify is only 6kb

/* istanbul ignore next */
export default (html) => (__SERVER__ ? '' : sanitize(html)); // do not sanitize on server since dompurify would do that on client
